import { z } from 'zod';

// Re-export site enums for convenience
export { LangCode, CountryCode, CurrencyCode } from './site.js';

// Timestamp — ISO 8601 datetime string
export const Timestamp = z.string().datetime();
export type Timestamp = z.infer<typeof Timestamp>;

// HexColor — #RRGGBB
export const HexColor = z.string().regex(/^#[0-9A-Fa-f]{6}$/, 'Invalid hex color');
export type HexColor = z.infer<typeof HexColor>;

// Slug — lowercase, alphanumeric, hyphens
export const Slug = z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Invalid slug');
export type Slug = z.infer<typeof Slug>;

// Decimal string (monetary values stored as strings to avoid floating-point issues)
export const DecimalString = z.string().regex(/^\d+(\.\d{1,2})?$/, 'Invalid decimal string');
export type DecimalString = z.infer<typeof DecimalString>;
